import { useCallback, useState } from "react";
import Popup from "../../../components/Popup";
import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import Book from "../../../assets/img/SolutionsIcons/AgilysysBook.svg";
import { Header } from "../../../components/Header";

const BookFPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const [showVideo, setShowVideo] = useState<boolean>(false);
    return (
      <div className="page splash bookPage">
        <div className="page-title">
          <img src={Book} alt="" />
        </div>
        <Header />
        <div className="text-blocks">
          <div className="std-text">
            An easy-to-use reservation system that is designed to move residents
            effortlessly through the booking process for spa appointments,
            rounds of golf, and more.{"\n\n"}
          </div>
          <div className="std-text">
            The flexible, configurable solution displays real-time availability
            and the ability to offer service enhancements. The result is
            increased revenue at lower booking cost.
          </div>
        </div>
        {/*<div
          className="play-video"
          onClick={() => {
            _logEvent("click", "Solutions - Book", "Play Video");
            addFlow("Play Video");
            setShowVideo(true);
          }}
        >
          <PlayTriangle />
          Play Video
        </div>*/}
        <img
          className="img-1"
          src={
            "https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/book3.png"
          }
          alt=""
        />
        <img
          className="img-2"
          src={
            "https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/book2.png"
          }
          alt=""
        />
        <Popup
          showPopup={showVideo}
          setShowPopup={() => setShowVideo(false)}
          disableOffClick={true}
        >
          <>
            {showVideo && (
              <video
                autoPlay
                controls
                src={
                  "https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/videos/InteractiveBook2.mp4"
                }
              />
            )}
          </>
        </Popup>
      </div>
    );
}

export default BookFPage;